import { render } from "./VODTagsManage.vue?vue&type=template&id=41c0310d&scoped=true"
import script from "./VODTagsManage.vue?vue&type=script&lang=js"
export * from "./VODTagsManage.vue?vue&type=script&lang=js"

import "./VODTagsManage.vue?vue&type=style&index=0&id=41c0310d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c0310d"],['__file',"src/views/VodDash/VODTagsManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41c0310d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41c0310d', __exports__)) {
    api.reload('41c0310d', __exports__)
  }
  
  module.hot.accept("./VODTagsManage.vue?vue&type=template&id=41c0310d&scoped=true", () => {
    api.rerender('41c0310d', render)
  })

}


export default __exports__